<template>
  <q-layout
    view="lHh lpr lFf"
    container
    :style="`height: ${store.state.pageHeight - 50}px`"
    :class="$q.screen.gt.sm && 'custom-bg'"
  >
    <q-page-container v-show="currentView === 'feed'">
      <div>
        <div class="row items-center no-wrap q-py-sm q-px-md">
          <q-btn
            unelevated
            label="Overview"
            size="md"
            color="primary"
            class="gt-xs q-mr-sm"
            @click="dialogOverview = true"
          />
          <q-btn
            unelevated
            icon="list_alt"
            size="md"
            color="primary"
            class="lt-sm q-mr-sm"
            @click="dialogOverview = true"
          />
          <q-btn
            unelevated
            label="Settings"
            size="md"
            color="primary"
            class="gt-xs"
            @click="dialogFeedSettings = true"
          />
          <q-btn
            unelevated
            icon="settings"
            size="md"
            color="primary"
            class="lt-sm q-mr-sm"
            @click="dialogFeedSettings = true"
          />
          <q-space />

          <div :class="$q.screen.xs ? 'q-pr-md' : 'q-pr-lg'">
            <q-toggle
              dense
              v-close-popup
              v-model="displayCharts"
              label="Charts"
              color="primary"
              :size="$q.screen.xs ? 'md' : 'lg'"
            />
          </div>

          <div class="">
            <q-toggle
              dense
              v-close-popup
              v-model="displayOverfed"
              label="Feed Eval"
              color="accent"
              :size="$q.screen.xs ? 'md' : 'lg'"
            />
          </div>
        </div>
        <q-separator />

        <div
          :style="`height: ${store.state.pageHeight - 103}px`"
          class="scroll"
        >
          <div class="row justify-center q-px-md q-pt-lg">
            <div
              class="col-12 row items-center text-subtitle2 text-bold"
              style="max-width: 600px"
            >
              <div v-for="bin in BinIndicators" :key="bin.id" class="col-12">
                <BinOverview
                  :bin="bin"
                  :displayBtns="true"
                  @fillBin="fillBin"
                  @goToBinEntries="goToBinEntries"
                />
              </div>

              <FeederOverview
                :feeder="selectedFeeder"
                :displayBtns="true"
                @fillFeeder="fillFeeder"
                @goToFeederEntries="goToFeederEntries(selectedFeeder)"
              />
            </div>
          </div>

          <div v-if="!displayCharts" class="row justify-center q-px-md">
            <div
              class="col-12 row items-center text-subtitle2 text-bold"
              style="max-width: 600px"
            >
              <div class="col-12 row items-center q-py-xs">
                <div v-if="!displayCharts" class="col-7 row">
                  <div class="col q-pl-sm">Pond</div>
                  <div class="col-7 row">
                    <div class="col-6 q-pl-sm">Last</div>
                    <div class="col-auto q-pl-sm">
                      {{ CurrentLabel }}
                    </div>
                  </div>
                </div>
              </div>

              <q-separator class="full-width" color="grey-5" />
            </div>
          </div>

          <div class="row justify-center q-px-md">
            <div class="col-12 row items-center" style="max-width: 600px">
              <div v-if="!displayCharts" class="col row items-center">
                <div class="col-7 row q-py-xs">
                  <div class="col q-pl-sm">Totals</div>
                  <div class="col-7 row">
                    <div class="col-6 q-pl-sm">{{ LastTotal }}</div>
                    <div class="col-6 q-pl-sm">{{ CurrentTotal }}</div>
                  </div>
                </div>
                <q-separator class="full-width" color="grey-5" />
              </div>

              <div v-if="displayCharts" class="col-12 q-pt-sm q-pb-lg">
                <q-card>
                  <div class="text-h6 q-pl-md q-py-sm">Totals</div>
                  <q-separator class="full-width" />
                  <div class="row text-subtitle1 q-px-md q-py-sm">
                    <div class="col-6">
                      Last <span> - </span> {{ LastTotal }}
                    </div>
                    <div class="col-6">
                      <span v-if="feedDividerOption === 1"> Current </span>
                      <span v-if="feedDividerOption === 0"> Today </span>
                      <span> - </span> {{ CurrentTotal }}
                    </div>
                  </div>
                  <q-separator class="full-width" />
                  <div
                    :id="`chart-container-total`"
                    style="height: 160px"
                    class="q-pa-xs"
                  >
                    <FeedChart
                      :chartData="ChartTotals"
                      :chartId="'totals-chart'"
                    />
                  </div>
                </q-card>
              </div>
            </div>
          </div>

          <div id="ponds-container" class="scroll q-px-md q-pb-xl">
            <div class="row justify-center">
              <div
                v-for="pond in Ponds"
                :key="pond.name"
                class="col-12 row justify-center"
              >
                <div :class="displayCharts && 'q-pb-lg'" style="width: 600px">
                  <FeedPondRow
                    :pond="pond"
                    :FeederSelected="selectedFeeder"
                    :displayCharts="displayCharts"
                    :displayOverfed="displayOverfed"
                    :resizeWatcher="resizeWatcher"
                    :feedDividerOption="feedDividerOption"
                    :lastFeedingDates="lastFeedingDates"
                    @setLastFeedingDate="setLastFeedingDate"
                    @goToPondEntries="goToPondEntries"
                  />
                  <q-separator v-if="!displayCharts" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Fill Bin Dialog -->
        <q-dialog full-height persistent position="top" v-model="dialogFillBin">
          <q-card style="width: 450px" class="q-pa-md">
            <div
              :style="`max-height: ${store.state.pageHeight + 50}px`"
              class="scroll"
            >
              <div v-if="selectedBin">
                <BinOverview :bin="selectedBin" :buttons="false" />
              </div>

              <FillBin
                :transactionObj="transaction"
                :action="'create'"
                :bin="selectedBin"
                @close="dialogFillBin = false"
              />
            </div>
          </q-card>
        </q-dialog>

        <!-- Fill Feeder Dialog -->
        <q-dialog
          full-height
          persistent
          position="top"
          v-model="dialogFillFeeder"
        >
          <FillFeeder
            :Transaction="transaction"
            :Action="'create'"
            :SelectedFeeder="selectedFeeder"
            :BinOptions="BinOptions"
            :Bins="Bins"
            @close="dialogFillFeeder = false"
          />
        </q-dialog>

        <!-- Overview Dialog -->
        <q-dialog position="top" full-height v-model="dialogOverview">
          <q-card style="width: 450px">
            <div class="row items-center q-ma-md">
              <div class="col text-center text-h5">Overview</div>
              <q-btn
                unelevated
                icon="clear"
                color="primary"
                @click="dialogOverview = false"
              />
            </div>
            <q-separator style="padding-top: 1px" />

            <div
              class="scroll q-px-md q-pt-md"
              style="max-height: calc(100vh - 100px)"
            >
              <div class="text-subtitle1 q-pb-sm">
                <div class="row justify-between">
                  <div>Remaining Feed</div>
                  <div>{{ RemainingFeed.toLocaleString() }}</div>
                </div>
                <q-separator />
              </div>

              <div class="text-subtitle1 q-py-xs">
                <div class="row justify-between">
                  <div>Last 10 Feed Day Avg</div>
                  <div>{{ LastTenFeedAvg.toLocaleString() }}</div>
                </div>
                <q-separator />
              </div>

              <div class="text-subtitle1 q-py-sm">
                <div class="row justify-between">
                  <div>Feed Days</div>
                  <div>
                    {{ FeedDays.toFixed(1) }}
                  </div>
                </div>
                <q-separator />
              </div>

              <div v-if="displayTFA" class="text-subtitle1 q-py-sm">
                <div class="row justify-between">
                  <div>Farm TFA</div>
                  <div>{{ numberWithCommas(FarmTFA) }}</div>
                </div>
                <q-separator />
              </div>

              <div class="col-xs-12 col-md-6 q-pt-sm">
                <FeedContracts />
              </div>

              <div class="text-center text-primary text-h6 q-pt-lg">Bins</div>
              <div class="q-pt-md">
                <div v-for="bin in Bins" :key="bin.id + '_bin'" class="row">
                  <BinOverview
                    :bin="bin"
                    :displayBtns="true"
                    @fillBin="fillBin"
                    @goToBinEntries="goToBinEntries"
                  />
                </div>
              </div>

              <div class="text-center text-primary text-h6 q-pb-md q-pt-sm">
                Feeders
              </div>
              <div>
                <div
                  v-for="feeder in FeederOptions"
                  :key="feeder.id + '_feeder'"
                  class="row"
                >
                  <FeederOverview
                    :feeder="feeder"
                    :displayBtns="true"
                    @fillFeeder="fillFeeder"
                    @goToFeederEntries="goToFeederEntries(feeder)"
                  />
                </div>
              </div>
            </div>
          </q-card>
        </q-dialog>

        <!-- Feed Settings Dialog -->
        <q-dialog
          position="top"
          full-height
          persistent
          v-model="dialogFeedSettings"
        >
          <q-card style="width: 450px">
            <div class="row items-center q-ma-md">
              <div class="col text-center text-h5">Feed Settings</div>
            </div>
            <q-separator />

            <div
              class="scroll"
              :style="`max-height: ${store.state.pageHeight - 180}px`"
            >
              <div class="text-center text-bold text-primary bg-grey-1 q-py-xs">
                Device Settings
              </div>
              <q-separator />

              <div class="q-px-md">
                <div class="q-pa-sm text-subtitle1 text-bold text-center">
                  <div>Feeder</div>
                </div>
                <q-separator />

                <div class="q-py-sm">
                  <div
                    v-for="feeder in FeederOptions"
                    :key="feeder.value"
                    class="q-px-md q-py-sm"
                  >
                    <q-radio
                      dense
                      v-model="selectedFeederVal"
                      :val="feeder.value"
                      :label="feeder.label"
                      color="primary"
                      size="lg"
                      @input="changeFeeder"
                      padding="10px md"
                    />
                  </div>
                </div>
                <q-separator />

                <div class="q-pa-sm text-subtitle1 text-bold text-center">
                  <div>Bin Indicators</div>
                </div>
                <q-separator />

                <div class="row q-pt-md">
                  <div
                    v-for="(bin, index) in Bins"
                    :key="bin.id"
                    class="col-12 row q-px-md q-pb-md"
                  >
                    <q-toggle
                      dense
                      v-model="binDisplayToggles[index]"
                      color="primary"
                      :label="decoder(bin.name)"
                      size="lg"
                      :disable="!bin.in_service"
                      @input="toggleBinDisplay(bin, index)"
                    />
                  </div>
                </div>
                <q-separator />

                <div class="q-pa-sm text-subtitle1 text-bold text-center">
                  <div>Chart Options</div>
                </div>
                <q-separator />

                <div class="q-px-md q-pb-sm q-pt-md">
                  <q-toggle
                    dense
                    v-model="feedingsAllDisplay"
                    label="Display All Feedings"
                    color="primary"
                    size="lg"
                    padding="10px md"
                  />
                </div>
                <div class="q-px-md q-py-sm">
                  <q-toggle
                    dense
                    v-model="feedingsMorningDisplay"
                    label="Display Morning Feedings"
                    color="primary"
                    size="lg"
                    padding="10px md"
                  />
                </div>
                <div class="q-px-md q-pt-sm q-pb-md">
                  <q-toggle
                    dense
                    v-model="feedingsEveningDisplay"
                    label="Display Evening Feedings"
                    color="primary"
                    size="lg"
                    padding="10px md"
                  />
                </div>
              </div>

              <div v-if="IsAdmin || IsAccountOwner">
                <q-separator />

                <div
                  class="text-center text-bold text-primary bg-grey-1 q-py-xs"
                >
                  Farm Feed Settings
                </div>
                <q-separator />

                <div class="q-px-md">
                  <div class="q-pa-sm text-subtitle1 text-bold text-center">
                    <div>Feed Options</div>
                  </div>
                  <q-separator />
                  <div class="q-py-sm">
                    <div class="q-px-md q-py-sm">
                      <q-radio
                        dense
                        v-model="feedDividerOption"
                        :val="0"
                        label="Use full days for Last & Today"
                        color="primary"
                        size="lg"
                        padding="10px md"
                        @input="setFarmFeedSettings"
                      />
                    </div>
                    <div class="q-px-md q-py-sm">
                      <q-radio
                        dense
                        v-model="feedDividerOption"
                        :val="1"
                        label="Use morning and evening for Last & Current"
                        color="primary"
                        size="lg"
                        padding="10px md"
                        @input="setFarmFeedSettings"
                      />
                    </div>
                  </div>
                  <q-separator />

                  <div class="q-pa-sm text-subtitle1 text-bold text-center">
                    <div>Morning / Evening Divide Time</div>
                  </div>
                  <q-separator />

                  <div class="q-py-sm">
                    <div class="q-px-md q-py-sm">
                      <q-radio
                        dense
                        v-model="divideTime"
                        :val="11"
                        label="11:00 AM"
                        color="primary"
                        size="lg"
                        padding="10px md"
                        @input="setFarmFeedSettings"
                      />
                    </div>
                    <div class="q-px-md q-py-sm">
                      <q-radio
                        dense
                        v-model="divideTime"
                        :val="12"
                        label="12:00 PM"
                        color="primary"
                        size="lg"
                        padding="10px md"
                        @input="setFarmFeedSettings"
                      />
                    </div>
                    <div class="q-px-md q-py-sm">
                      <q-radio
                        dense
                        v-model="divideTime"
                        :val="1"
                        label="1:00 PM"
                        color="primary"
                        size="lg"
                        padding="10px md"
                        @input="setFarmFeedSettings"
                      />
                    </div>
                    <div class="q-px-md q-py-sm">
                      <q-radio
                        dense
                        v-model="divideTime"
                        :val="2"
                        label="2:00 PM"
                        color="primary"
                        size="lg"
                        padding="10px md"
                        @input="setFarmFeedSettings"
                      />
                    </div>
                  </div>
                  <q-separator />

                  <div class="q-pa-sm text-subtitle1 text-bold text-center">
                    <div>Display TFA</div>
                  </div>
                  <q-separator />

                  <div class="q-px-md q-pt-md q-pb-lg">
                    <q-toggle
                      dense
                      v-model="displayTFA"
                      label="Display TFA"
                      color="primary"
                      size="lg"
                      padding="10px md"
                      @input="setFarmFeedSettings"
                    />
                  </div>
                </div>
                <q-separator />

                <div
                  class="text-center text-bold text-primary bg-grey-1 q-py-xs"
                >
                  Farm Bin Settings
                </div>
                <q-separator />

                <div class="q-px-md">
                  <div class="q-pa-sm text-center">
                    <div class="text-subtitle1 text-bold">
                      Default Bin Selection
                    </div>
                    <div>(On Feeder Fillups)</div>
                  </div>
                  <q-separator />

                  <div class="q-px-md q-pt-md q-pb-lg">
                    <q-toggle
                      dense
                      v-model="defaultBinSelection"
                      label="Default Bin Selection"
                      color="primary"
                      size="lg"
                      padding="10px md"
                      @input="setFarmFeedSettings"
                    />
                  </div>
                  <q-separator />

                  <div class="q-pa-sm text-subtitle1 text-bold text-center">
                    <div>In Service</div>
                  </div>
                  <q-separator />

                  <div class="row q-pt-md">
                    <div
                      v-for="(bin, index) in Bins"
                      :key="bin.id + 'in_service'"
                      class="col-12 row q-px-md q-pb-md"
                    >
                      <q-toggle
                        dense
                        v-model="inServiceBins[index]"
                        color="primary"
                        :label="decoder(bin.name)"
                        size="lg"
                        @input="toggleInServiceBin(bin, index)"
                      />
                    </div>
                  </div>
                  <q-separator />

                  <div class="q-pa-sm text-center">
                    <div class="text-subtitle1 text-bold">Bin Sort Order</div>
                    <div>(drag & drop)</div>
                  </div>
                  <q-separator />

                  <div class="q-pt-md q-pb-lg">
                    <draggable
                      v-model="binSortList"
                      group="bins"
                      @end="setBinSortList"
                    >
                      <div
                        v-for="(bin, index) in binSortList"
                        :key="bin.id + 'binSortList'"
                        class="q-pb-sm"
                      >
                        <q-card flat class="bg-grey-2 q-py-xs q-px-md">
                          <div style="cursor: move" class="row justify-between">
                            <div>
                              {{ decoder(bin.name) }}
                            </div>
                            <div>
                              {{ index + 1 }}
                            </div>
                          </div>
                        </q-card>
                      </div>
                    </draggable>
                  </div>
                </div>
              </div>
            </div>
            <q-separator />

            <div class="row justify-end q-pa-md">
              <q-btn label="Apply" color="primary" v-close-popup />
            </div>
          </q-card>
        </q-dialog>
      </div>
    </q-page-container>

    <q-page-container v-if="currentView === 'binEntries'">
      <BinDetail
        :bin="selectedBin"
        :goToBin="GoToBin"
        @back="currentView = 'feed'"
        @goToNext="goToBinNext"
        @goToPrevious="goToBinPrevious"
      />
    </q-page-container>

    <q-page-container v-if="currentView === 'feederEntries'">
      <FeederDetail
        :SelectedFeeder="selectedFeederDetail"
        @back="currentView = 'feed'"
      />
    </q-page-container>

    <q-page-container v-if="currentView === 'pondEntries'">
      <PondDetail
        :FeederSelected="selectedFeeder"
        :pond="selectedPond"
        :goToPond="GoToPond"
        @goToNext="goToPondNext"
        @goToPrevious="goToPondPrevious"
        @back="closePondDetail"
      />
    </q-page-container>
  </q-layout>
</template>

<script>
import BinOverview from '@/components/feed/BinOverview.vue';
import BinDetail from '@/components/feed/BinDetail.vue';
import FeederOverview from '@/components/feed/FeederOverview.vue';
import FeederDetail from '@/components/feed/FeederDetail.vue';
import FeedPondRow from '@/components/feed/FeedPondRow.vue';
import FillBin from '@/components/feed/FillBin.vue';
import FillFeeder from '@/components/feed/FillFeeder.vue';
import FeedChart from '@/components/feed/FeedChart.vue';
import FeedContracts from '@/components/feed/Contracts.vue';
import PondDetail from '@/components/feed/PondDetail.vue';

import { date } from 'quasar';
import draggable from 'vuedraggable';
import store from '@/store';
import {
  decoder,
  numberWithCommas,
  isNumValid,
  cloneObj,
  getPercentage,
  getScrollbarWidth,
  smartCompare,
  sortOrderCompare
} from '@/lib/helpers';
import {
  createTransactionObj,
  getUID,
  guidMatchHelper
} from '@/store/transactionHelpers';
import { isDateValid, setTimeOfDay } from '@/lib/date-utils.js';
import AuthUtils from '@/lib/auth-utils';
import {
  getCurrentByFeeding,
  getCurrentByDay,
  getLastByFeeding,
  getLastByDay,
  getChartData,
  getChartTotals
} from '@/lib/feedingHelpers';

export default {
  name: 'FeedEntries',
  components: {
    BinOverview,
    BinDetail,
    FeederOverview,
    FeederDetail,
    FeedPondRow,
    FillBin,
    FillFeeder,
    FeedChart,
    FeedContracts,
    draggable,
    PondDetail
  },
  data() {
    return {
      binDisplayToggles: [],
      binIndicators: [],
      binSortList: [],
      currentView: 'feed',
      decoder,
      defaultBinSelection: true,
      dialogFeedSettings: false,
      dialogFillBin: false,
      dialogFillFeeder: false,
      dialogOverview: false,
      displayTFA: true,
      divideTime: 12,
      feederPlaceholder: {
        balance: 0,
        capacity: 0,
        name: ''
      },
      feedingsAllDisplay: true,
      feedingsEveningDisplay: true,
      feedingsMorningDisplay: true,
      inServiceBins: [],
      isDateValid,
      isNumValid,
      feedDividerOption: 0,
      lastFeedingDates: {},
      numberWithCommas,
      resizeWatcher: false,
      selectedBin: null,
      selectedFeederVal: null,
      selectedFeeder: {
        balance: 0,
        capacity: 0,
        name: ''
      },
      selectedFeederDetail: null,
      selectedPond: null,
      store,
      displayCharts: false,
      displayOverfed: false,
      transaction: createTransactionObj()
    };
  },
  mounted() {
    this.setFeeder();
    this.setFeedSettingsInitial();
    this.setBinDisplayToggles();
    this.setInServiceBins();
    this.binSortList = cloneObj(this.Bins);
  },
  methods: {
    closePondDetail() {
      if (this.displayCharts) {
        this.displayCharts = false;

        // charts need to be re-rendered
        // for some reason
        this.$nextTick(() => {
          this.displayCharts = true;
        });
      }

      this.currentView = 'feed';
    },
    changeFeeder() {
      const feeder = this.FeederOptions.find(
        (x) => x.value === this.selectedFeederVal
      );

      localStorage.setItem('feederSelected', feeder.value);

      this.selectedFeeder = cloneObj(feeder);
    },
    fillBin(bin) {
      this.transaction = createTransactionObj();
      this.transaction.pounds = '0';
      this.transaction.date = date.formatDate(new Date(), 'MM/DD/YYYY');
      this.selectedBin = this.Bins.find((x) => x.grain_id === bin.grain_id);

      this.dialogFillBin = true;
    },
    fillFeeder() {
      this.transaction = createTransactionObj();
      this.transaction.pounds = '0';

      if (store.state.farm.settings.default_bin_selection) {
        this.transaction.from_account =
          this.selectedFeeder?.fillUps[0]?.from_account ?? null;
      }

      this.dialogFillFeeder = true;
    },
    goToBinEntries(bin) {
      this.dialogOverview = false;
      this.selectedBin = cloneObj(bin);
      this.currentView = 'binEntries';
    },
    goToBinNext() {
      const index = this.Bins.findIndex((x) => x.id === this.selectedBin.id);

      const bin = cloneObj(this.Bins[index + 1]);
      this.goToBinEntries(bin);
    },
    goToBinPrevious() {
      const index = this.Bins.findIndex((x) => x.id === this.selectedBin.id);

      const bin = cloneObj(this.Bins[index - 1]);
      this.goToBinEntries(bin);
    },
    goToFeederEntries(feeder) {
      this.selectedFeederDetail = cloneObj(feeder);

      this.dialogOverview = false;
      this.currentView = 'feederEntries';
    },
    goToPondEntries(pond) {
      this.selectedPond = cloneObj(pond);
      this.currentView = 'pondEntries';
    },
    goToPondNext() {
      const index = this.Ponds.findIndex((x) => x.id === this.selectedPond.id);

      const pond = cloneObj(this.Ponds[index + 1]);
      this.goToPondEntries(pond);
    },
    goToPondPrevious() {
      const index = this.Ponds.findIndex((x) => x.id === this.selectedPond.id);

      const pond = cloneObj(this.Ponds[index - 1]);
      this.goToPondEntries(pond);
    },
    setBinDisplayToggles() {
      const binDisplayToggles =
        JSON.parse(localStorage.getItem('binDisplayToggles')) ?? [];

      this.binDisplayToggles = [];
      for (const bin of this.Bins) {
        const binToggle = binDisplayToggles.find((x) => x.binId === bin.id);

        if (!binToggle) {
          this.binDisplayToggles.push(false);

          binDisplayToggles.push({
            binId: bin.id,
            display: false
          });
        } else {
          this.binDisplayToggles.push(binToggle.display);
        }
      }

      localStorage.setItem(
        'binDisplayToggles',
        JSON.stringify(binDisplayToggles)
      );
    },
    async setBinSortList() {
      // loop through this.Bins and update the sort order
      for (let i = 0; i < this.binSortList.length; i++) {
        const bin = cloneObj(this.binSortList[i]);

        if (i !== bin.sort_order) {
          bin.storeInfo = {
            farmId: store.state.farm.id
          };
          bin.sort_order = i;

          store.dispatch('updateBin', {
            bin
          });
        }
      }
    },
    setInServiceBins() {
      this.inServiceBins = [];
      for (const bin of this.Bins) {
        this.inServiceBins.push(bin.in_service);
      }
    },
    setChartOptions() {
      const feedSettings = {
        feedingsAllDisplay: this.feedingsAllDisplay,
        feedingsMorningDisplay: this.feedingsMorningDisplay,
        feedingsEveningDisplay: this.feedingsEveningDisplay
      };

      localStorage.setItem('feedSettings', JSON.stringify(feedSettings));
    },
    setFarmBinSettings() {
      if (this.IsAdmin || this.IsAccountOwner) {
        const farmSettings = cloneObj(store.state.farm.settings);
        farmSettings.default_bin_selection = this.defaultBinSelection;

        store.dispatch('updateFarmSettings', { farmSettings });
      }
    },
    setFarmFeedSettings() {
      if (this.IsAdmin || this.IsAccountOwner) {
        const farmSettings = cloneObj(store.state.farm.settings);
        farmSettings.feed_divider_option = parseInt(this.feedDividerOption);
        farmSettings.feed_divider_time = parseInt(this.divideTime);
        farmSettings.display_tfa = this.displayTFA;
        farmSettings.default_bin_selection = this.defaultBinSelection;

        store.dispatch('updateFarmSettings', { farmSettings });
      }
    },
    setFeedSettingsInitial() {
      let feedSettings = localStorage.getItem('feedSettings');

      if (!feedSettings) {
        feedSettings = {
          feedingsAllDisplay: this.feedingsAllDisplay,
          feedingsMorningDisplay: this.feedingsMorningDisplay,
          feedingsEveningDisplay: this.feedingsEveningDisplay,
          feedDividerOption: this.feedDividerOption
        };

        localStorage.setItem('feedSettings', JSON.stringify(feedSettings));
        return;
      }

      feedSettings = JSON.parse(feedSettings);

      this.feedingsAllDisplay = feedSettings.feedingsAllDisplay;
      this.feedingsMorningDisplay = feedSettings.feedingsMorningDisplay;
      this.feedingsEveningDisplay = feedSettings.feedingsEveningDisplay;
      this.feedDividerOption =
        store.state.farm?.settings?.feed_divider_option ?? 0;
      this.divideTime = store.state.farm?.settings?.feed_divider_time ?? 12;
      this.displayTFA = store.state.farm?.settings?.display_tfa ?? true;
      this.defaultBinSelection =
        store.state.farm?.settings?.default_bin_selection ?? true;
    },
    setFeeder() {
      const deviceFeeder = localStorage.getItem('feederSelected');

      if (!deviceFeeder) {
        this.selectedFeeder = cloneObj(this.FeederOptions[0]);
        this.selectedFeederVal = this.selectedFeeder.value;

        localStorage.setItem('feederSelected', this.selectedFeederVal);

        return;
      }

      const feeder = this.FeederOptions.find(
        (x) => x.value === parseInt(deviceFeeder)
      );

      // if user switched farms
      if (!feeder) {
        this.selectedFeeder = cloneObj(this.FeederOptions[0]);
        this.selectedFeederVal = this.selectedFeeder.value;
        localStorage.setItem('feederSelected', this.selectedFeederVal);

        return;
      }

      this.selectedFeeder = cloneObj(feeder);
      this.selectedFeederVal = this.selectedFeeder.value;
    },
    toggleBinDisplay(toggledBin, toggledIndex) {
      const binDisplayToggles =
        JSON.parse(localStorage.getItem('binDisplayToggles')) ?? [];

      const index = binDisplayToggles.findIndex(
        (x) => x.binId === toggledBin.id
      );

      const display = this.binDisplayToggles[toggledIndex];

      if (index === -1) {
        binDisplayToggles.push({ binId: toggledBin.id, display });
      } else {
        binDisplayToggles[index].display = display;
      }

      localStorage.setItem(
        'binDisplayToggles',
        JSON.stringify(binDisplayToggles)
      );

      this.setBinDisplayToggles();
    },
    toggleInServiceBin(toggledBin, toggledIndex) {
      const bin = cloneObj(toggledBin);

      bin.in_service = this.inServiceBins[toggledIndex];

      if (!bin.in_service) {
        this.binDisplayToggles[toggledIndex] = false;
        this.toggleBinDisplay(bin, toggledIndex);
      }

      bin.storeInfo = {
        farmId: store.state.farm.id
      };

      store.dispatch('updateBin', {
        bin
      });
    },
    setLastFeedingDate(pondId, feedingDate) {
      this.lastFeedingDates[pondId] = feedingDate;

      // Have to clone the object to trigger the reactivity :(
      this.lastFeedingDates = cloneObj(this.lastFeedingDates);
    }
  },
  computed: {
    BinIndicators() {
      const indicators = [];
      for (let i = 0; i < this.Bins.length; i++) {
        if (this.binDisplayToggles[i]) {
          indicators.push(this.Bins[i]);
        }
      }

      return indicators;
    },
    BinOptions() {
      const options = [];
      for (const bin of this.Bins) {
        if (!bin.in_service) {
          continue;
        }

        // get the feed type of the bin - which is the feed type of the latest delivery
        let feedTypeId = null;
        let feedTypeName = '---';
        for (const entry of bin.deliveries) {
          if (entry.mill_name) {
            feedTypeId = entry.feed_type;
            feedTypeName = entry.feed_type_name;
            break;
          }
        }

        options.push({
          id: bin.id,
          balance: bin.balance,
          name: bin.name,
          label: bin.name + ' -- ' + feedTypeName,
          value: bin.grain_id,
          feedTypeId,
          feedTypeName
        });
      }

      return options;
    },
    Bins() {
      const bins = cloneObj(store.state.farm.bins)
        .filter((x) => !x.archived)
        .map((x) => ({ ...x, binLevel: getPercentage(x.balance, x.capacity) }))
        .sort((a, b) => smartCompare(a.name, b.name))
        .sort((a, b) => a.sort_order - b.sort_order);

      return bins;
    },
    ChartTotals() {
      return getChartTotals(
        this.Ponds,
        this.feedingsAllDisplay,
        this.feedingsMorningDisplay,
        this.feedingsEveningDisplay
      );
    },
    CurrentLabel() {
      return this.feedDividerOption === 0 ? 'Today' : 'Current';
    },
    CurrentTotal() {
      let total = 0;
      for (const pond of this.Ponds) {
        if (this.feedDividerOption === 0) {
          total += getCurrentByDay(pond.feedings).pounds;
        } else {
          total += getCurrentByFeeding(pond.feedings).pounds;
        }
      }

      return numberWithCommas(total);
    },
    FarmTFA() {
      let tfa = 0;
      for (const pond of this.Ponds) {
        tfa += pond.growth?.targetFeedAmount ?? 0;
      }
      return tfa;
    },
    FeedDays() {
      return this.LastTenFeedAvg ? this.RemainingFeed / this.LastTenFeedAvg : 0;
    },
    FeederLevelPercent() {
      return getPercentage(
        this.selectedFeeder.balance,
        this.selectedFeeder.capacity
      );
    },
    FeederOptions() {
      const options = [];
      for (const feeder of store.state.farm.feeders) {
        if (feeder.archived) {
          continue;
        }

        // get the feed type of the feeder
        let feedTypeId = null;
        let feedTypeName = '---';
        for (const entry of feeder.fillUps) {
          if (entry.feed_type) {
            feedTypeId = entry.feed_type;
            feedTypeName = entry.feed_type_name;
            break;
          }
        }

        options.push({
          id: feeder.id,
          balance: feeder.balance,
          label: feeder.name,
          value: feeder.grain_id,
          feedTypeId,
          feedTypeName,
          ...feeder
        });
      }

      return options;
    },
    IsAccountOwner() {
      const userRole = AuthUtils.roleDecoder(this.$store.getters.userFarmRole);
      return userRole === 'Account owner';
    },
    IsAdmin() {
      return this.$store.state.user.feedx_level === 'super-admin';
    },
    GoToBin() {
      const index =
        this.Bins.findIndex((bin) => bin.id === this.selectedBin.id) ?? 0;

      const next = index < this.Bins.length - 1;
      const previous = index > 0;

      return { next, previous };
    },
    GoToPond() {
      const index =
        this.Ponds.findIndex((pond) => pond.id === this.selectedPond.id) ?? 0;

      const next = index < this.Ponds.length - 1;
      const previous = index > 0;

      return { next, previous };
    },
    LastTenFeedAvg() {
      let totalFeed = 0;
      const days = new Set();
      const daysMap = new Map();
      for (const pond of store.state.farm.ponds) {
        for (const entry of pond.feedings) {
          const feedDayTS = +new Date(
            date.startOfDate(new Date(entry.date * 1000), 'day')
          );

          if (daysMap.has(feedDayTS)) {
            daysMap.set(feedDayTS, daysMap.get(feedDayTS) + entry.pounds);
          } else {
            daysMap.set(feedDayTS, entry.pounds);
          }
        }
      }

      const daysSortedArr = Array.from(daysMap.keys())
        .sort()
        .reverse()
        .slice(0, 10);

      for (const day of daysSortedArr) {
        totalFeed += daysMap.get(day);
      }

      return Math.round(totalFeed / 10);
    },
    LastTotal() {
      let total = 0;
      for (const pond of this.Ponds) {
        let lastFeedingDate = this.lastFeedingDates[pond.id] * 1000;
        lastFeedingDate = +new Date(
          date.startOfDate(new Date(lastFeedingDate), 'day')
        );

        let feedingSkipped = false;
        for (const feedingDate of Object.values(this.lastFeedingDates)) {
          let feedingDateStart = feedingDate * 1000;
          feedingDateStart = +new Date(
            date.startOfDate(new Date(feedingDateStart), 'day')
          );

          if (feedingDateStart > lastFeedingDate) {
            feedingSkipped = true;
            break;
          }
        }

        const lastFeeding =
          this.feedDividerOption === 0
            ? getLastByFeeding(pond.feedings)
            : getLastByDay(pond.feedings);

        if (!feedingSkipped) {
          total += lastFeeding.pounds;
        }
      }

      return numberWithCommas(total);
    },
    Ponds() {
      const singleLocation = this.SelectedLocation === 'SINGLE_LOCATION';

      return this.$store.state.farm.ponds
        .filter(
          (x) =>
            (x.location_name === this.SelectedLocation || singleLocation) &&
            !x.archived
        )
        .sort(sortOrderCompare)
        .map((x) => {
          const chartData = getChartData(
            x,
            this.feedingsAllDisplay,
            this.feedingsMorningDisplay,
            this.feedingsEveningDisplay
          );
          return { ...x, chartData };
        });
    },
    RemainingFeed() {
      let feed = 0;
      for (const bin of this.$store.state.farm.bins) {
        const bal = parseFloat(bin.balance);
        feed += bal > 0 ? bal : 0;
      }

      for (const feeder of this.$store.state.farm.feeders) {
        const bal = parseFloat(feeder.balance);
        feed += bal > 0 ? bal : 0;
      }

      return feed;
    },
    ScrollbarWidth() {
      return getScrollbarWidth();
    },
    SelectedLocation() {
      return this.$store.state.selectedLocation;
    }
  },
  watch: {
    Bins() {
      this.setBinDisplayToggles();
      this.setInServiceBins();
      this.binSortList = cloneObj(this.Bins);

      this.selectedBin =
        this.$store.state.farm.bins.find(
          (x) => x.id === this.selectedBin?.id ?? null
        ) || {};
    },
    FeederOptions() {
      this.setFeeder();

      this.selectedFeederDetail =
        this.FeederOptions.find(
          (x) => x.id === this.selectedFeederDetail?.id ?? null
        ) || {};
    },
    Ponds() {
      const pond = this.Ponds.find(
        (x) => x.id === this.selectedPond?.id ?? null
      );

      if (pond) {
        this.selectedPond = cloneObj(pond);
      }
    }
  }
};
</script>

<style></style>
